
<script>
import { shopInfosEmits, shopInfosProps, useShopInfos } from "./mixin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
export default {
  name: "ShopInfo",
  components: {
    Icon,
    Button
  },
  props: {
    ...shopInfosProps()
  },
  emits: [...shopInfosEmits()],
  setup(props, context) {
    const { lastSlotAvailable, togglePlanningPopin } = useShopInfos(
      props,
      context
    );
    return { lastSlotAvailable, togglePlanningPopin };
  }
};
</script>
<template>
  <div class="u-flex">
    <Icon
      name="shipping-drv"
      size="xlg"
      variant="primary"
      class="u-mr-sm u-flex-shrink-none"
    />
    <div>
      <h2 class="u-font-500 u-mb-xs u-font-17@md">
        Prochain créneau Drive disponible
      </h2>
      <p class="u-font-500 u-mb-md u-mb-sm@md">{{ shopName }}</p>
      <p
        class="u-font-19 u-font-16@md u-color-primary u-font-600 u-mb-sm"
        v-if="shopfirstSlotAvailable!=='indisponible'"
      >{{ shopfirstSlotAvailable }}</p>
      <p
        class="u-font-19 u-font-16@md u-font-600 u-mb-sm"
        v-else
      > Aucun créneau n'est disponible pour le moment
      </p>

      <Button
        @click="togglePlanningPopin()"
        link
      >
        Voir le planning
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
